import React from "react";
import { Upload } from "lucide-react";
import "./SavingVideoOverlay.scss";

function SavingVideoOverlay() {
  return (
    <div className="saving-video-overlay">
      <div className="overlay-card">
        <div className="card-header">
          <div className="icon-wrapper primary">
            <Upload size={20} />
          </div>
          <div className="header-text">
            <h3 className="title">Saving Your Recording</h3>
            <p className="subtitle">Please wait while your video is being uploaded</p>
          </div>
        </div>

        <div className="card-body">
          <div className="spinner-container">
            <div className="spinner" />
          </div>
          <div className="progress-info">
            <p className="progress-text">Upload in progress...</p>
            <p className="progress-hint">This may take a moment depending on your connection</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SavingVideoOverlay;
